import React from 'react';
import { connect } from 'react-redux';
import { compose, branch, renderNothing, setDisplayName } from 'recompose';
import CurrentPackage from './CurrentPackage';
import PaymentDetails from './PaymentDetails';
import Upgrade from './Upgrade';
import SubscriptionRenew from './SubscriptionRenew';
import { getCurrentSubscription } from '../../../selectors';
import styles from './Subscriptions.scss';
import transformServiceId from '../../../helpers/transformServiceId';

const ACTIVE_STATUS = 'Active';

function Subscriptions({
  currentPackage, renewPackage, services, creditCard, selectedOption,
}) {
  const isSubscriptionExpired =
        currentPackage &&
        currentPackage.accountSubscriptionInfo.recurringPaymentInfo.statusInfo.statusDescription !==
            ACTIVE_STATUS;
  const isUpgradeNeeded = services.length > 0;
  const isVip = currentPackage && currentPackage.defaultSubscriptionInfo.customParameters.IsVIP;

  return (
    <div className={styles.root}>
      <section className={styles.subscription}>
        <div className={styles.package}>
          <div className={styles.current}>
            <CurrentPackage
              service={currentPackage}
              expired={isSubscriptionExpired}
              vip={isVip && Boolean(Number(isVip))}
                        />
          </div>
          <PaymentDetails
            card={creditCard}
            expired={isSubscriptionExpired}
            vip={isVip && Boolean(Number(isVip))}
                    />
        </div>
        <SubscriptionRenew
          data={renewPackage}
          serviceId={selectedOption && selectedOption.priceId}
          expired={isSubscriptionExpired}
                />
      </section>
      <Upgrade
        services={services}
        expired={isSubscriptionExpired}
        needUpgrade={isUpgradeNeeded}
            />
    </div>
  );
}

function mapStateToProps(state) {
  const currentPackage = state.userServices.data !== null ? getCurrentSubscription(state) : null;
  let packagesToUpgrade;
  let renewPackage;

  if (currentPackage) {
    packagesToUpgrade = currentPackage.upgradeTo;
    renewPackage = state.subscriptions.options.find(service =>
      transformServiceId(currentPackage.defaultSubscriptionInfo.subscriptionId) ===
                service.id);
  }

  return {
    currentPackage,
    renewPackage,
    services: packagesToUpgrade || [],
    creditCard: state.userInfo.data !== null ? state.userInfo.data.CreditCard : {},
    selectedOption:
            currentPackage &&
            state.subscriptions.options.find(service => currentPackage.defaultSubscriptionInfo.subscriptionId === service.id),
  };
}

export default compose(
  setDisplayName('Subscriptions'),
  connect(mapStateToProps),
  branch(props => !props.currentPackage, renderNothing),
)(Subscriptions);
